export default __webpack_public_path__ + "static/media/office10full.56e61de6.jpg";